import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Intellapulse · Your Data, Amplified</p>
        <h1>Unlock the Power of Your Data.</h1>
        <p className="lede">
          At Intellapulse, we empower you to harness your data for smarter decisions. Explore our innovative solutions designed for everyday consumers looking to optimize their lives.
        </p>
        <div className="cta-row">
          <a href="https://intellapulse.com/get-started" target="_blank">
            Get Started
          </a>
          <a href="https://intellapulse.com/about" target="_blank" className="secondary">
            Learn More
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Effortless Insights</h2>
          <p>
            Transform your data into actionable insights with our user-friendly tools that make analysis simple and effective.
          </p>
        </article>
        <article>
          <h2>Personalized Solutions</h2>
          <p>
            Customize your experience with tailored features that meet your unique needs, ensuring you get the most out of your data.
          </p>
        </article>
        <article>
          <h2>Stay Ahead</h2>
          <p>
            Leverage our advanced analytics to stay informed and make proactive decisions that keep you ahead of the curve.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;